export const formatTaxId = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  const limitedDigits = digits.slice(0, 9);
  
  if (limitedDigits.length <= 2) {
    return limitedDigits;
  } else {
    return `${limitedDigits.slice(0, 2)}-${limitedDigits.slice(2)}`;
  }
};

export const unformatTaxId = (value: string): string => {
  return value.replace(/\D/g, '');
};
